import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./slices/profileSlice";

const store = configureStore({
  reducer: {
    userProfile: profileReducer,
  },
});

export default store;
